import {
  LayoutPlugin,
  ButtonPlugin,
  ModalPlugin,
  FormInputPlugin,
  FormRadioPlugin,
  CollapsePlugin,
  NavPlugin,
  NavbarPlugin,
  ListGroupPlugin,
  FormCheckboxPlugin,
  TooltipPlugin,
  ProgressPlugin,
  PaginationPlugin,
  TablePlugin,
  CarouselPlugin,
  BVConfigPlugin,
  FormSelectPlugin
} from 'bootstrap-vue'

export default function registerBootstrapVuePlugins(app) {
  app.use(BVConfigPlugin, {
    BDropdown: {
      // Setting "aria-haspopup" to "false" to fix a conflict between it and "aria-expanded" on voiceOver (iOS), for more detail see: https://sdui.atlassian.net/browse/GG-515
      role: 'false',
      popperOpts: {
        placement: 'left-start'
      }
    }
  })
  app.use(LayoutPlugin)
  app.use(ProgressPlugin)
  app.use(ModalPlugin)
  app.use(ButtonPlugin)
  app.use(FormInputPlugin)
  app.use(CollapsePlugin)
  app.use(NavPlugin)
  app.use(NavbarPlugin)
  app.use(ListGroupPlugin)
  app.use(TooltipPlugin)
  app.use(TablePlugin)
  app.use(FormCheckboxPlugin)
  app.use(CarouselPlugin)
  app.use(PaginationPlugin)
  app.use(FormRadioPlugin)
  app.use(FormSelectPlugin)
}
